import { IHttpApi } from '@cian/http-api/shared';

import {
  createNotesModel,
  TNoteAction,
  TNotesResponseScheme,
  ICreateNotesModelParams,
} from '../../../packages/monolith-python/notes';
import { EDealType, EOfferType } from 'shared/types/offers';

export interface ISaveNoteApiParams {
  oid: number;
  text: string | undefined;
  action: TNoteAction;
  csrf_token: string;
}

export interface ISaveNoteParams extends ISaveNoteApiParams {
  offerType: EOfferType;
  dealType: EDealType;
  httpApi: IHttpApi;
}

export interface IApiParamsSaveNote extends ISaveNoteParams {
  subdomain: string | undefined;
}

export function updateOfferNoteApi(params: IApiParamsSaveNote): Promise<TNotesResponseScheme> {
  const { httpApi, offerType, dealType, subdomain, ...apiParams } = params;
  const createNotesModelParams: ICreateNotesModelParams = {
    offerType,
    dealType,
    config: { parameters: { ...prepareParams(apiParams) } },
  };

  return httpApi.fetch(createNotesModel(createNotesModelParams), {
    requestConfig: {
      headers: [['Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8']],
      withCredentials: true,
    },
    subdomain,
    bodyAsEncodeString: true,
  }) as Promise<TNotesResponseScheme>;
}

export function prepareParams({ oid, ...rest }: ISaveNoteApiParams) {
  return { oid: oid.toString(), ...rest };
}
